import { Component } from '@angular/core';

@Component({
  selector: 'apex-delete-checklist-item-dialog',
  templateUrl: './delete-item-dialog.component.html',
})
export class DeleteChecklistItemDialogComponent {
  archiveCheck = true;
}
